import { render, staticRenderFns } from "./DialogImportIdpExamRegister.vue?vue&type=template&id=703f9913"
import script from "./DialogImportIdpExamRegister.vue?vue&type=script&lang=js"
export * from "./DialogImportIdpExamRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports